import * as types from "./actiontypes"

const initialState = {
    clientworkData: null,
    isLoading: false,
    isError: false
}

export const Clientworkreducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_CLIENTWORK_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.GET_CLIENTWORK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                clientworkData: payload
            }

        case types.GET_CLIENTWORK_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                // massage: ""
            }

        case types.CREATE_CLIENTWORK_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.CREATE_CLIENTWORK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                clientworkData: payload
            }

        case types.CREATE_CLIENTWORK_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }

        default:
            return state
    }
}